module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iRWJlbmVfMSIgZGF0YS1uYW1lPSJFYmVuZSAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj48dGl0bGU+WmVpY2hlbmZsw6RjaGUgNTwvdGl0bGU+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEzNi41NSwxMjVsNTEuMzYtNTEuMzZhOC4xNiw4LjE2LDAsMCwwLTExLjU0LTExLjU1TDEyNSwxMTMuNDUsNzMuNjQsNjIuMDlBOC4xNyw4LjE3LDAsMCwwLDYyLjA5LDczLjY0TDExMy40NiwxMjUsNjIuMDksMTc2LjM2YTguMTcsOC4xNywwLDEsMCwxMS41NSwxMS41NUwxMjUsMTM2LjU1bDUxLjM3LDUxLjM2YTguMTYsOC4xNiwwLDAsMCwxMS41NC0xMS41NVptMCwwIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/svg/cancel-white.svg
// module id = W6Kt
// module chunks = 1